import { getEmailRegex } from 'hb-react/shared/constants/emailRegex';
import isValueEmpty from 'hb-react/shared/utils/isValueEmpty';

export const errorMessage = __('Must be a valid email');

const emailRegex = getEmailRegex();

export const validateEmailFormat = (value) => {
  let error;

  if (isValueEmpty(value)) {
    return error;
  }

  if (!emailRegex.test(value)) {
    error = errorMessage;
  }

  return error;
};
